// extracted by mini-css-extract-plugin
export default {"broadBandContainer":"cssmodule_style-module__broadBandContainer--m1Ixc"};